export default "__VITE_ASSET__l53u3qit__"